import { openDB } from "idb";

const DB_NAME = "stellar_offline_v1";
const STORE_CACHE = "cache";     // GET responses by URL
const STORE_OUTBOX = "outbox";   // pending mutations
const STORE_ENTITIES = "entities"; // materialized appointments/customers/services

const dbp = openDB(DB_NAME, 1, {
  upgrade(db) {
    db.createObjectStore(STORE_CACHE);
    db.createObjectStore(STORE_OUTBOX, { keyPath: "id", autoIncrement: true });
    db.createObjectStore(STORE_ENTITIES, { keyPath: "_pk" });
  },
});

export async function cacheGet(url) {
  return (await dbp).get(STORE_CACHE, url);
}
export async function cacheSet(url, data) {
  return (await dbp).put(STORE_CACHE, data, url);
}

export async function enqueue(op) {
  const db = await dbp;
  // Rename entity id to avoid colliding with outbox autoIncrement 'id' primary key.
  const { id: entityId, ...rest } = op;
  await db.add(STORE_OUTBOX, {
    ...rest,
    entity_id: entityId,
    created_at: new Date().toISOString(),
  });
  return getQueue();
}
export async function getQueue() {
  return (await dbp).getAll(STORE_OUTBOX);
}
export async function removeFromQueue(id) {
  return (await dbp).delete(STORE_OUTBOX, id);
}
export async function clearQueue() {
  return (await dbp).clear(STORE_OUTBOX);
}

/** Merge locally-optimistic items into a fetched list (dedupe by tmp id) */
export function mergeOptimistic(baseList, optimistic) {
  const ids = new Set(baseList.map((x) => x.id));
  return [...baseList, ...optimistic.filter((x) => !ids.has(x.id))];
}

export async function putEntity(entity, item) {
  const db = await dbp;
  await db.put(STORE_ENTITIES, { ...item, _pk: `${entity}:${item.id}` });
}
export async function deleteEntity(entity, id) {
  const db = await dbp;
  await db.delete(STORE_ENTITIES, `${entity}:${id}`);
}
export async function listEntities(entity) {
  const db = await dbp;
  const all = await db.getAll(STORE_ENTITIES);
  return all.filter((x) => x._pk.startsWith(`${entity}:`)).map(({ _pk, ...rest }) => rest);
}

/** Create a temporary id for offline-created items */
export const tmpId = () => `tmp_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
export const isTmpId = (id) => typeof id === "string" && id.startsWith("tmp_");
